import { inject } from '@angular/core';

import { ContactResourceService } from '../contact-resource.service';

export const contactGuard = () => {
    const contactResourceService = inject(ContactResourceService);
    if (contactResourceService.guideRouteValidation()) {
        return true;
    } else return false;
};
